import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { css as r } from '../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = r`:host{box-sizing:border-box;display:block}:host .footnote-block{background-color:inherit}::slotted([slot=head]){display:block;font-size:16px;font-weight:600;line-height:20px;padding-bottom:10px}@media (min-width:1024px){::slotted([slot=head]){font-size:24px;line-height:28px}}::slotted([slot=body]){display:block;font-size:16px;line-height:20px}`;

export { css_248z as default };
